import { Link } from 'react-router-dom';
import { AlertTriangle, Lock } from 'lucide-react';
import { useSubscriptionStatus } from '@/hooks/usePlans';

/** App-wide notice once a paid plan has lapsed: how many grace days remain, or that the account is read-only. */
export default function SubscriptionBanner() {
  const { data } = useSubscriptionStatus();
  if (!data || data.phase === 'ACTIVE') return null;

  const readOnly = data.phase === 'READ_ONLY';
  const days = data.graceDaysLeft;
  return (
    <div
      role="alert"
      className={`flex items-center gap-3 px-4 py-2.5 text-sm ${
        readOnly ? 'bg-red-600 text-white' : days <= 7 ? 'bg-amber-500 text-secondary-900' : 'bg-amber-100 text-amber-900'
      }`}
    >
      {readOnly ? <Lock className="h-4 w-4 shrink-0" /> : <AlertTriangle className="h-4 w-4 shrink-0" />}
      <p className="flex-1">
        {readOnly
          ? 'Your subscription has expired and the grace period has ended. The account is read-only until you renew.'
          : `Your subscription has expired. You have ${days} day${days === 1 ? '' : 's'} of grace left before the account becomes read-only; new buildings and units are blocked until you renew.`}
      </p>
      <Link to="/settings/plan" className="shrink-0 rounded-lg bg-white/90 px-3 py-1 font-semibold text-secondary-900 hover:bg-white">
        Renew now
      </Link>
    </div>
  );
}
